import {signUpTypes} from "../../../actions/AuthActions/AuthActionsTypes/SignUpActionsTypes";

const initState = {};

const SignUpErrorReducer = (state = initState, action) => {
    switch (action.type) {
        case signUpTypes.SET_ERROR: {
            return Object.assign({}, state, {
                [action.name]: action.message,
            });
        }

        case signUpTypes.SET_ERRORS: {
            return Object.assign({}, state, {
                ...action.message,
            });
        }

        case signUpTypes.REMOVE_ERRORS: {
            return initState;
        }

        default: {
            return state;
        }
    }
};

export default SignUpErrorReducer;
